<div class="card">
  <div class="card-body d-flex flex-center flex-column py-9 px-5">
    <div class="symbol symbol-65px symbol-circle mb-5">
      @if (horse.image_url && horse.image_url.length > 0) {
        <img src="{{horse.image_url}}" alt="image"/>
      } @else {
        <img src="assets/images/horse_placeholder.png" alt="image" />
      }
    </div>
    <a href="#" class="fs-4 text-gray-800 text-hover-primary fw-bold mb-0">{{horse.name}}</a>
    <div class="fw-semibold text-gray-500 mb-6">{{ horse.breed }}</div>
    <div class="d-flex flex-center flex-wrap mb-5">
      <div class="border border-dashed rounded min-w-90px py-3 px-4 mx-2 mb-3">
        <div class="fs-6 fw-bold text-gray-700">{{ horse.color }}</div>
        <div class="fw-semibold text-gray-500">Color</div>
      </div>
      <div class="border border-dashed rounded min-w-90px py-3 px-4 mx-2 mb-3">
        <div class="fs-6 fw-bold text-gray-700">{{ getHorseGenderLabel(horse.gender) }}</div>
        <div class="fw-semibold text-gray-500">Gender</div>
      </div>
    </div>
    <div class="button-container d-flex flex-row">
      <app-button
        [label]="'View horse'"
        [variant]="'primary'"
        [iconClass]="'fa fa-eye'"
        class="me-2"
        (clicked)="goToThread()"
      />
      <app-button
        [label]="'Edit horse'"
        [variant]="'outline'"
        [iconClass]="'fa fa-edit'"
        class="me-2"
        (clicked)="emitEditHorseClick()"
      />
      <app-button
        [variant]="'outline'"
        [iconClass]="'fa fa-trash'"
        (clicked)="emitDeleteHorseClick()"
      />
    </div>
  </div>
</div>
